import { Route, Routes } from 'react-router-dom';
import { YMInitializer } from 'react-yandex-metrika';

import Card from './components/screens/Card/Card';
import Checkout from './components/screens/Checkout/Checkout';
import { About } from './main/About';
import Error404 from './pages/404/404';
import { Catalog } from './pages/Catalog';
import { Checkout as OldCheckout } from './pages/Checkout';

/*import { Checkout } from './pages/Checkout';*/
import { Favorites } from './pages/Favorites';
import { LegalEntity } from './pages/LegalEntity';
import Main from './pages/Main';
import { OrderInfo } from './pages/OrderInfo';
import { PaymentAndDelivery } from './pages/PaymentAndDelivery';
import { Publication } from './pages/Publication';
import { PublicationCard } from './pages/PublicationCard';
import { SearchPage } from './pages/Search';

export const AppRouter = () => {
  return (
    <>
      <Routes>
        {/* Главная */}
        <Route path="/" element={<Main />} />
        {/* Каталог товара */}
        <Route path="/:catalogType/:slug" element={<Catalog />} />
        {/* Страница товара(эелемента) */}
        <Route path="/old-basket" element={<OldCheckout />} />
        {/* Корзина */}
        <Route path="/basket" element={<Checkout />} />
        {/* Корзина */}
        <Route path="/order-info" element={<OrderInfo />} />
        {/* Статьи / Публикации */}
        <Route path="/articles" element={<Publication />} />
        {/* Карта публикаций */}
        <Route path="/articles/:slug" element={<PublicationCard />} />
        {/* Избранное */}
        <Route path="/favorites" element={<Favorites />} />
        {/* Поиск */}
        <Route path="/search" element={<SearchPage />} />
        {/* Оплата и доставка */}
        <Route path="/payment-and-delivery" element={<PaymentAndDelivery />} />
        {/* Юридическим лицам */}
        <Route path="/legal-entity" element={<LegalEntity />} />
        {/* О проекте */}
        <Route path="/about" element={<About />} />
        {/* О проекте */}
        <Route path="/404" element={<Error404 />} />
        {/* Карточка тест */}
        <Route path="/items/:slug" element={<Card />} />
      </Routes>
      {/* Яндекс метрика */}
      <YMInitializer
        accounts={[52282966]}
        options={{
          clickmap: true,
          trackLinks: true,
          accurateTrackBounce: true,
          webvisor: true,
          ecommerce: 'dataLayer',
        }}
        version="2"
      />
    </>
  );
};
